<template>
    <div>
        <el-menu :default-active="menuName" class="el-menu" @open="handleOpen" @close="handleClose" :collapse="isCollapse" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
            <h3>{{ isCollapse ? subtitle : title }}</h3>
            <el-menu-item @click="clickMenu(item)" v-for="item in noChildren" :key="item.name" :index="item.name">
                <i :class="`el-icon-${item.icon}`"></i>
                <span slot="title">{{ item.label }}</span>
            </el-menu-item>
            <el-submenu v-for="item in hasChildren" :key="item.label" :index="item.label">
                <template slot="title">
                    <i :class="`el-icon-${item.icon}`"></i>
                    <span slot="title">{{ item.label }}</span>
                </template>
                <el-menu-item-group>
                    <el-menu-item @click="clickMenu(subItem)" v-for="subItem in item.children" :key="subItem.path" :index="subItem.path">{{ subItem.label }}</el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
    </div>
</template>

<style lang="less" scoped>
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        min-height: 400px;
    }
    .el-menu {
        height: 100vh;
        border-right: 0;
        h3 {
            color: #fff;
            text-align: center;
            line-height: 48px;
            font-size: 16px;
            font-weight: 400;
            padding: 0 16px;
        }
    }
</style>

<script>
    export default {
        data () {
            return {
                title: process.env.VUE_APP_TITLE,
                subtitle: process.env.VUE_APP_SUBTITLE,
                menuName: 'home',
                menuData: [
                    {
                        path: '/home',
                        name: 'home',
                        label: '首页',
                        icon: 's-home',
                        url: 'Home/Home'
                    },
                    {
                        path: '/user',
                        name: 'user',
                        label: '用户管理',
                        icon: 'user',
                        url: 'User/User'
                    },
                    {
                        label: '设备管理',
                        icon: 's-goods',
                        children: [
                            {
                                path: '/belt',
                                name: 'belt',
                                label: '智能项圈',
                                icon: 'setting',
                                url: 'Device/Belt'
                            },
                            {
                                path: '/camera',
                                name: 'camera',
                                label: '扫码重置设备',
                                icon: 'setting',
                                url: 'Device/camera'
                            },
                            {
                                path: '/devices',
                                name: 'devices',
                                label: '批量轨迹回放',
                                icon: 'setting',
                                url: '/devices'
                            }
                        ]
                    },
                    {
                        path: '/product',
                        name: 'product',
                        label: '生产管理',
                        icon: 'attract',
                        url: 'Product/product'
                    },
                    {
                        name: 'firmwares',
                        label: '固件管理',
                        icon: 'setting',
                        children: [
                            {
                                path: '/hw_upgrade',
                                name: 'hw_upgrade',
                                label: '新增硬件版本',
                                icon: 'setting',
                                url: 'Firmwares/hw_upgrade'
                            },
                            {
                                path: '/beltbootfirmware',
                                name: 'beltbootfirmware',
                                label: '项圈BOOT固件',
                                icon: 'setting',
                                url: 'Firmwares/beltbootfirmware'
                            },
                            {
                                path: '/beltappfirmware',
                                name: 'beltappfirmware',
                                label: '项圈APP固件',
                                icon: 'setting',
                                url: 'Firmwares/beltappfirmware'
                            }
                        ]
                    },
                    {
                        path: '/simCards',
                        name: 'simCards',
                        label: 'SIM卡管理',
                        icon: 'bank-card',
                        url: 'SimCards'
                    }
                ]
            };
        },
        methods: {
            handleOpen (key, keyPath) {
                console.log(key, keyPath);
            },
            handleClose (key, keyPath) {
                console.log(key, keyPath);
            },
            //点击菜单
            clickMenu (item) {
                console.log(item);
                // 当页面路由与跳转路由不一致时，才允许跳转
                console.log('route', this.$route.path)
                console.log('item', item.path)
                if (item.external) {
                    console.log('card manager: ', item.url)
                    window.open(item.url, '_blank');
                } else
                    if (this.$route.path !== item.path && !(this.$route.path === '/home' && item.path === '/'))
                        this.$router.push(item.path);
            }
        },
        computed: {
            // 没有子菜单
            noChildren () {
                return this.menuData.filter(item => !item.children);
            },
            // 有子菜单
            hasChildren () {
                return this.menuData.filter(item => item.children);
            },
            isCollapse () {
                return this.$store.state.tab.isCollapse;
            },
            username () {
                return this.$store.state.user.username;
            },
        },
        mounted () {
            if (this.$store.state.user.authAcc.includes(this.username)) {
                this.menuData = [
                    {
                        label: '设备管理',
                        icon: 's-goods',
                        children: [
                            {
                                path: '/belt',
                                name: 'belt',
                                label: '智能项圈',
                                icon: 'setting',
                                url: 'Device/Belt'
                            }
                        ]
                    }
                ]
            }
            let _name = ''
            this.menuData.forEach(item => {
                if (item.path === this.$route.path) {
                    _name = item.name
                } else if (item.children) {
                    item.children.forEach(o => {
                        if (o.path === this.$route.path) {
                            _name = '/' + o.name
                        }
                    })
                }
            })
            this.menuName = _name || 'home'
        }
    }
</script>